export const entityTypeOptions = () => {
  return [
    {
      id: 1,
      name: 'Veiculos',
      slug: 'VEHICLE',
    },
    {
      id: 2,
      name: 'Implementos',
      slug: 'WAGON',
    },
    {
      id: 3,
      name: 'Motoristas',
      slug: 'DRIVER',
    },
  ];
};

export const mediaTypeOptions = () => {
  return [
    { id: 1, name: 'Licenciamento', slug: 'LICENCIAMENTO' },
    { id: 2, name: 'Liberação', slug: 'LIBERAÇÃO' },
    { id: 3, name: 'Outros', slug: 'OUTROS' },
    { id: 4, name: 'Tacografo', slug: 'TACOGRAFO' },
    { id: 5, name: 'Dedetização', slug: 'DEDETIZACAO' },
    { id: 6, name: 'Permisso', slug: 'PERMISSO' },
    { id: 7, name: 'Ficha Técnica', slug: 'REVISAO TECNICA' },
    { id: 8, name: 'Outros Documentos', slug: 'OUTROS_DOCUMENTOS' },
    { id: 9, name: 'RG', slug: 'RG' },
    { id: 10, name: 'Liberação GR', slug: 'LIBERACAO_GR' },
    { id: 11, name: 'Comprovante Endereço', slug: 'COMPROVANTE_ENDERECO' },
    { id: 12, name: 'CNH', slug: 'CNH' },
    { id: 13, name: 'Cartões', slug: 'CARTOES' },
    { id: 14, name: 'Frente CNH', slug: 'front_cnh' },
    { id: 15, name: 'Verso CNH', slug: 'back_cnh' },
  ];
};
